/* eslint-disable react/jsx-boolean-value */
import { useEffect, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ButtonWithSpinner from '../buttons/ButtonWithSpinner';
import './CustomDialog.scss';
import LiveChatService from '../../services/LiveChatService';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Dialog component.
 */
const defaultProps = {
  openDialog: false,
  onClose: () => {},
  title: '',
  displayCloseIcon: true,
  actions: null,
  className: '',
  onEntered: () => null,
  onExisting: () => null,
  fullScreen: false,
  autoFocus: false,
};

export default function CustomDialog(props) {
  const {
    openDialog,
    className,
    onClose,
    title,
    content,
    displayCloseIcon,
    actions,
    onEntered,
    onExisting,
    fullScreen,
    autoFocus,
  } = { ...defaultProps, ...filterUndefined(props) };
  const dialogRef = useRef(null);

  useEffect(() => {
    if (openDialog) {
      LiveChatService.hideLiveChatIcon();
    } else {
      LiveChatService.showLiveChatIcon();
    }
    return () => {
      LiveChatService.showLiveChatIcon();
      onExisting?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      open={openDialog}
      onClose={(e, reason) => {
        if (reason === 'backdropClick') {
          return;
        }
        onClose(e, reason);
      }}
      maxWidth='md'
      fullWidth={false}
      fullScreen={fullScreen}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      className={`custom-dialog-component ${className}`}
      ref={dialogRef}
      data-test='custom-dialog-modal'
      autoFocus={autoFocus}
      TransitionProps={{
        onEntered: (e) => {
          /* Fix the issues when there are multiple popups on the screen, the input fields
           * on the subsequenc dialogs does not work
          */
          dialogRef.current.querySelector('.MuiDialog-container').removeAttribute('tabindex');
          onEntered?.(e);
        },
        onExisting,
      }}
    >
      {title || displayCloseIcon ? (
        <DialogTitle data-test='custom-dialog-title' onClose={onClose} className='custom-dialog-title'>
          {title}
          {displayCloseIcon ? (
            <IconButton
              data-test='custom-dialog-close-icon'
              aria-label='close'
              className='custom-dialog-icon-button'
              onClick={onClose}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.stopPropagation();
                  event.preventDefault();
                  onClose();
                }
              }}
            ><CloseIcon />
            </IconButton>
          ) : ''}
        </DialogTitle>
      ) : null}

      <DialogContent className='custom-dialog-content' data-test='custom-dialog-content'>
        {content}
      </DialogContent>
      {
        actions && actions.length > 0 ? (
          <DialogActions className='vizzle-custom-dialog-actions'>
            {actions.map((action, index) => (
              action.isCustomComponent ? action.component : (
                <ButtonWithSpinner
                  key={`custom-dialog-action-${index}`}
                  onClick={action.onClick}
                  color={action.color}
                  className={action.className}
                  label={action.title}
                  disabled={action.disabled}
                  loading={action.loading}
                  ref={action.ref}
                  data-test={`custom-dialog-actions-${index}`}
                  tabIndex={0}
                />
              )
            ))}
          </DialogActions>
        ) : null
      }

    </Dialog>
  );
}
